import React,{useState,useEffect} from "react";


const ObesityPatientForm = ({
  id,
  setId,
  patientname,
  setName,
  age,
  setAge,
  height,
  setHeight,
  weight,
  setWeight,
  sleep_duration,
  setSleepDuration,
  gender,
  setGender,
  family_history,
  setFamilyHistory,
  tsh_level,
  setTshLevel,

  obese_level,
  setObeseLevel,

  dateOfVisit,
  setDateOfVisit,
}) => {
  const [bmi, setBmi] = useState('');
  useEffect(() => {
    if (height > 0 && weight > 0) {
      const bmiValue = (weight / ((height / 100) ** 2)).toFixed(2);
      setBmi(bmiValue);
    } else {
      setBmi('');
    }
  }, [height, weight]);

  return (
    <div className="max-w-7xl mx-auto rounded-lg overflow-hidden">
      {/* <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-6">
        <h2 className="text-3xl font-bold text-white">Patient Information Form</h2>
      </div> */}
      <form className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <FormField
            label="Patient ID"
            type="text"
            id="patientid"
            value={id}
            onChange={(e) => e.preventDefault()}
            placeholder="Enter Patient ID"
            readOnly
            disabled
          />
          <FormField
            label="Patient Name"
            type="text"
            id="patientname"
            value={patientname}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Patient Name"
          />
          <FormField
            label="Gender"
            type="select"
            id="gender"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
          >
            <option value="">Select Gender</option>
            <option value="0">Male</option>
            <option value="1">Female</option>
          </FormField>
          <FormField
            label="Patient Age"
            type="text"
            id="age"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            placeholder="Enter Age"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <FormField
            label="Height (cm)"
            type="number"
            id="height"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            placeholder="Enter Height"
          />
          <FormField
            label="Weight (kg)"
            type="number"
            id="weight"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            placeholder="Enter Weight"
          />
          <FormField label="BMI" type="number" id="bmi" value={bmi} onChange={() => {}} placeholder="BMI" readOnly />


        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        <FormField
            label="Sleep Duration"
            type="number"
            id="sleep-duration"
            value={sleep_duration}
            onChange={(e) => setSleepDuration(e.target.value)}
            placeholder="Enter Sleep Duration"
          />
          <FormField
            label="Family History"
            type="select"
            id="family-history"
            value={family_history}
            onChange={(e) => setFamilyHistory(e.target.value)}
          >
            <option value="">Obesity in family history</option>
            <option value="0">No</option>
            <option value="1">Rare</option>
            <option value="2">Common</option>
          </FormField>
          <FormField
            label="TSH Level"
            type="number"
            id="tsh-level"
            value={tsh_level}
            onChange={(e) => setTshLevel(e.target.value)}
            placeholder="Enter TSH Level"
          />

        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">

          <FormField
            label="Obese Level"
            type="select"
            id="obese-level"
            value={obese_level}
            onChange={(e) => setObeseLevel(e.target.value)}
          >
            <option value="">Select Obese Level</option>
            <option value="Under_Weight">UnderWeight</option>
            <option value="Normal_Weight">Over Normal Weight</option>
            <option value="Over_Weight">Over Weight</option>
            <option value="Obese">Obese</option>
            <option value="Morbid_Obesity">Morbid Obesity</option>
          </FormField>

          <FormField
            label="Date of Visit"
            type="date"
            id="dateofvisit"
            value={dateOfVisit}
            onChange={(e) => setDateOfVisit(e.target.value)}
          />
        </div>
      </form>
    </div>
  );
};

const FormField = ({
  icon,
  label,
  type,
  id,
  value,
  onChange,
  placeholder,
  children,
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="flex items-center text-gray-700 font-semibold mb-2"
      >
        <span className="text-indigo-600 mr-2">{icon}</span>
        {label}
      </label>
      {type === "select" ? (
        <select
          id={id}
          className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition duration-200 ease-in-out sm:text-sm"
          value={value}
          onChange={onChange}
        >
          {children}
        </select>
      ) : (
        <input
          type={type}
          id={id}
          className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition duration-200 ease-in-out sm:text-sm"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default ObesityPatientForm;
